import Box from "@mui/material/Box";
import "./LongPreview.css";

const LongQuestion = ({ question }) => {
  //const { isActive } = question;

  return (
    <>
      <Box className="long-question__preview">
        <p>Long Answer</p>
        <div className="long-question__line" />
        <div className="long-question__line long-question__line--spaced " />
      </Box>
    </>
  );
};

export default LongQuestion;
